// extracted by mini-css-extract-plugin
export default {"conitaner":"MarketPageItems_conitaner__ZLGna","no-skins":"MarketPageItems_no-skins__juVvl","main-container":"MarketPageItems_main-container__CjmBV"};